import { getBanksFunction } from '@/common/queries/selections/Banks/banksFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBanksOption = () =>
  queryOptions({
    queryKey: ['get_bank'],
    queryFn: () => getBanksFunction(),
  });
